import { RootState } from '../../RootState';

const selectAccessToken = (state: RootState): string | null => state.auth.accessToken;

export default selectAccessToken;
